import React from "react";
import { useTranslation } from "react-i18next";
import { ColumnProps, defaultColumnProps } from "../../../../DataTable/ColumnProps";

// We want to highlight packages that skip ahead in the package number sequence
function PackageNumberColumn({ width }: ColumnProps = defaultColumnProps) {
    const { t } = useTranslation();

    return {
        Header: t<string>('LotDetails.Packages.BoxNumber'),
        accessor: 'containerNumber',
        filter: 'includesString',
        Cell: (props: any) => {
            return (
                <div>
                    {props.row.original.missingPackageEmphasis
                        ? <strong>{props.value}</strong>
                        : props.value}
                </div>
            );
        },
        width: width
    };
}

export default PackageNumberColumn;